import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import('../views/coreTechnology/technology.vue')
  },
  {
    path: '/systemPatform',
    name: 'systemPatform',
    component: () => import('../views/coreTechnology/systemPatform.vue')
  },
  {
    path: '/information',
    name: 'information',
    component: () => import('../views/product/information.vue')
  },
  {
    path: '/information1',
    name: 'information1',
    component: () => import('../views/product/information1.vue')
  },
  {
    path: '/information2',
    name: 'information2',
    component: () => import('../views/product/information2.vue')
  },
  {
    path: '/chartItems',
    name: 'chartItems',
    component: () => import('../views/pipeline/chartItems.vue')
  },
  {
    path: '/chartSample',
    name: 'chartSample',
    component: () => import('../views/pipeline/chartSample.vue')
  },
  {
    path: '/companyProfile',
    name: 'companyProfile',
    component: () => import('../views/about/companyProfile.vue')
  },
  {
    path: '/ourPurpose',
    name: 'ourPurpose',
    component: () => import('../views/about/ourPurpose.vue')
  },
  {
    path: '/management',
    name: 'management',
    component: () => import('../views/about/management.vue')
  },
  {
    path: '/cmpanyNews',
    name: 'cmpanyNews',
    component: () => import('../views/newsroom/cmpanyNews.vue')
  },
  {
    path: '/industryNews',
    name: 'industryNews',
    component: () => import('../views/newsroom/industryNews.vue')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/newsroom/details.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact/contact.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
